<template>
  <v-menu
    v-model="displayMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <v-text-field
      ref="textField"
      slot="activator"
      :placeholder="$t('date-month-placeholder')"
      v-model="dateFormatted"
      :label="label"
      :rules="rules"
      :hint="hint"
      persistent-hint
    ></v-text-field>
    <v-date-picker
      v-model="date"
      no-title
      @input="onDatePickerInput"
      :picker-date.sync="initialDate"
      :min="min"
      type="month"
      :locale="locale"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import i18n from '@/helpers/i18n'
import { Consts } from '@/helpers/consts'

export default {
  data() {
    return {
      displayMenu: false,
      lastPickerDate: null
    }
  },
  props: {
    value: {
      required: true,
      validator: prop => {
        return typeof prop === 'string' || prop === null
      }
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    label: {
      type: String,
      required: true
    },
    pickerDate: {
      type: String,
      required: false
    },
    min: {
      type: String,
      required: false
    },
    hint: {
      type: String,
      required: false,
      default: ''
    }
  },
  watch: {
    pickerDate: function(newVal) {
      if (!this.value) {
        this.lastPickerDate = newVal
      }
    }
  },
  computed: {
    locale: function() {
      return i18n.locale() === Consts.LANG_FR ? 'fr' : 'en-us'
    },
    date: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change')
      }
    },
    dateFormatted: {
      get() {
        if (this.date === null) {
          return ''
        }

        let [year, month] = this.date.split('-')
        return `${month}/${year}`
      },
      set(val) {
        if (val.length === 7 && val.indexOf('/') === 2) {
          let [month, year] = val.split('/')
          this.date = `${year}-${month}-01`
        }
      }
    },
    initialDate: {
      get() {
        return this.lastPickerDate || this.value || this.pickerDate
      },
      set(value) {
        this.lastPickerDate = value
      }
    }
  },
  methods: {
    onDatePickerInput: function() {
      this.displayMenu = false
    },
    validate: function() {
      this.$refs.textField.validate()
    }
  }
}
</script>
